import { trackEvent } from "@/lib/dataLayer";
import { useEffect, useRef } from "react";
import { useLocation } from "react-router";

const THRESHOLD = 0.75;

// `enabled` deixa o disparo pausado enquanto a página ainda não tem o
// conteúdo real (ex.: skeleton de loading), evitando medir profundidade
// contra um layout provisório.
export const useScrollDepth = (enabled = true) => {
  const firedRef = useRef(false);
  const { pathname } = useLocation();

  useEffect(() => {
    if (typeof window === "undefined" || !enabled) return;

    // Reseta a cada pathname: sem isso, navegar client-side entre páginas
    // que reusam o mesmo componente (ex.: /blog/:slug -> /blog/:slug2 via
    // React Router, que não remonta o componente) nunca dispararia o evento
    // de novo depois do primeiro post lido na sessão.
    firedRef.current = false;

    const handleScroll = () => {
      if (firedRef.current) return;

      const scrollTop = window.scrollY;
      const viewport = window.innerHeight;
      const docHeight = document.documentElement.scrollHeight;
      const scrollable = docHeight - viewport;
      if (scrollable <= 0) return;

      const ratio = (scrollTop + viewport) / docHeight;
      if (ratio >= THRESHOLD) {
        firedRef.current = true;
        trackEvent({
          event: "scroll_depth_75",
          page_path: window.location.pathname,
        });
        window.removeEventListener("scroll", handleScroll);
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll();

    return () => window.removeEventListener("scroll", handleScroll);
  }, [enabled, pathname]);
};
